<template>
  <div>
    <div class="d-flex justify-space-between pa-3 bg-darkblue mb-1 radius-bottom">
      <div class="text-body-1 font-weight-bold">{{ nom_coureur }} {{ parcours_coureur }}</div>
    </div>
    <div class="py-2 px-1">
      <v-expansion-panels variant="default" v-model="current_step_inscription">
        <v-expansion-panel value="1">
          <v-expansion-panel-title :readonly="!is_openable(1)" color="lightblue" class="text-h6">Choix des parcours
            <template v-slot:actions="{ expanded }">
              <v-icon :color="getColor(expanded, '1')" :icon="getIcon(expanded, '1')"></v-icon>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <SelectionParcours :item="inscription" :initial_commande_inscription="initial_commande_inscription"
              @goToNextStep="goToIdentityStep()"></SelectionParcours>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel value="2">
          <v-expansion-panel-title :readonly="!is_openable(2)" color="lightblue" class="text-h6">Identité du participant
            <template v-slot:actions="{ expanded }">
              <v-icon :color="getColor(expanded, '2')" :icon="getIcon(expanded, '2')"></v-icon>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div class="d-flex justify-start mb-3">
              <v-btn variant="outlined" size="small" color="primary-dark" @click="current_step_inscription = '1'"
                v-if="!mainStore.billetterie_mode"><v-icon icon="mdi-arrow-up" class="mr-1"></v-icon> Précedent</v-btn>
            </div>
            <IdentiteCoureur :item="inscription" :initial_commande_inscription="initial_commande_inscription"
              :ids_parcours="ids_selected_parcours" @incoherence="incoherence" @goToNextStep="goToOptionsStep()">
            </IdentiteCoureur>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel value="3">
          <v-expansion-panel-title :readonly="!is_openable(3)" color="lightblue" class="text-h6"><span
              v-if="!mainStore.billetterie_mode">Options/Garanties/Code de réduction</span><span
              v-else>Billetterie</span>
            <template v-slot:actions="{ expanded }">
              <v-icon :color="getColor(expanded, '3')" :icon="getIcon(expanded, '3')"></v-icon>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div class="d-flex justify-start mb-3">
              <v-btn variant="outlined" size="small" color="primary-dark"
                @click="current_step_inscription = '2'"><v-icon icon="mdi-arrow-up" class="mr-1"></v-icon>
                Précedent</v-btn>
            </div>
            <SelectionOptions :item="inscription" :initial_commande_inscription="initial_commande_inscription">
            </SelectionOptions>
            <div class="d-flex justify-center">
              <v-btn class="sm-fullwidth" variant="outlined" size="small" color="primary-dark"
                @click="finishInscription()"><v-icon icon="mdi-arrow-down" class="mr-1"></v-icon> Continuer</v-btn>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-dialog width="500" max-width="100%" scroll-strategy="none" v-model="dialog_incoherence">
      <v-card>
        <v-card-text>
          <p>Attention ! On a besoin de vérifier ensemble :</p>
          <p v-if="!incoherence_response.nom_valide">Nous avons détecté un prénom dans le champ nom, nous vous invitons
            à
            vérifier votre saisie.</p>
          <p v-if="!incoherence_response.prenom_valide">Votre prénom nous est inconnu ! Une erreur de saisi à corrigé ?
          </p>
          <p v-if="!incoherence_response.sexe_valide">Le sexe sélectionné ne correspond pas au prénom indiqué, nous vous
            invitons à vérifier votre choix (HOMME/FEMME).</p>
          <p>Si c'est bien le votre, vous pouvez ignorer cette alerte et poursuivre votre inscription.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary-dark" block @click="dialog_incoherence = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import IdentiteCoureur from "@/components/Inscription/IdentiteCoureur.vue";
import SelectionParcours from "@/components/Inscription/SelectionParcours.vue";
import SelectionOptions from "@/components/Inscription/SelectionOptions.vue";
export default {
  props: ["item", "initial_commande_inscription"],
  components: { IdentiteCoureur, SelectionParcours, SelectionOptions },

  data() {
    return {
      inscription: {},
      current_step_inscription: "1",
      dialog_incoherence: false,
      incoherence_response: {},
      index: 0,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    ids_selected_parcours() {
      let ids = [];
      for (let i = 0; i < this.inscription.list_courses.list.length; i++) {
        if (this.inscription.list_courses.list[i].selected) {
          ids.push(this.inscription.list_courses.list[i].id);
        }
      }
      return ids;
    },
    nom_coureur() {
      let nom = this.inscription.coureur.get_nom();
      if (nom.length > 1) {
        return nom;
      }

      if (!this.mainStore.is_default_mode) {
        return "Participant n°" + parseInt(this.index + 1);
      } else {
        return "Coureur n°" + parseInt(this.index + 1);
      }
    },
    parcours_coureur() {
      let parcours = "";
      if (this.mainStore.billetterie_mode) {
        return "";
      }
      for (let i = 0; i < this.inscription.list_courses.list.length; i++) {
        if (this.inscription.list_courses.list[i].selected) {
          parcours += this.inscription.list_courses.list[i].nom + " ";
        }
      }
      if (this.mainStore.parcours_billetterie_mode) {
        return parcours;
      }
      parcours = parcours != "" ? parcours : "Aucun parcours sélectionné";
      return "- Parcours: " + parcours;
    },
  },

  watch: {
    "inscription.coureur": {
      deep: true,
      handler() {
        this.inscription.coureur;
      },
    },
  },
  methods: {
    incoherence(response) {
      if (!this.mainStore.is_default_mode) return;
      if (response) {
        if (!response.nom_valide || !response.prenom_valide || !response.sexe_valide) {
          this.incoherence_response = response;
          this.dialog_incoherence = true;
        }
      }
    },
    goToIdentityStep() {
      this.current_step_inscription = "2";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
    },

    goToOptionsStep() {
      this.current_step_inscription = "3";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
    },
    finishInscription() {
      this.inscription.finished = true;
      this.current_step_inscription = "4";
      this.bookingStore.compute_cart();
    },

    getIcon(expanded, step) {
      if (expanded) {
        return "mdi-pencil";
      }
      if (parseInt(step) < parseInt(this.current_step_inscription)) {
        return "mdi-check";
      }
      return "mdi-dots-horizontal";
    },
    getColor(expanded, step) {
      if (expanded || parseInt(step) > parseInt(this.current_step_inscription)) {
        return "";
      }
      return "dark-green";
    },
    is_openable(step) {
      return parseInt(step) < parseInt(this.current_step_inscription);
    },
  },

  created() {
    this.inscription = this.item;

    if (this.inscription.finished) {
      this.current_step_inscription = "4";
    }
    if (this.mainStore.billetterie_mode && !this.inscription.finished) {
      this.goToIdentityStep();
    }
  },
};
</script>

<style lang="scss" scoped></style>